<template>
    <CompassMenu placement="bottom-end" customClass="automation-create-automation__menu">
        <CompassButton
            :label="translations.createAutomation.labelButton"
            :loading="isLoading"
            dropdown
        />
        <template #dropdown>
            <CompassMenuItemExtended
                icon="obj-slsy-basic-automation"
                :title="translations.createAutomation.template"
                :caption="translations.createAutomation.templateCaption"
                @click="handleGoToTemplates"
            />
            <CompassMenuItemExtended
                icon="obj-slsy-advanced-services"
                :title="translations.createAutomation.services"
                :caption="translations.createAutomation.servicesCaption"
                @click="handleGoToServices"
            />
            <CompassMenuItemExtended
                icon="obj-slsy-advanced-automation"
                :title="translations.createAutomation.automation"
                :caption="translations.createAutomation.automationCaption"
                :flagProps="getFlagPropsCreateAutomation"
                :disabled="!hasAutomationBuilderFeature"
                :tooltipProps="getTooltipPropsCreateAutomation"
                @click="handleCreateAutomation"
            />
        </template>
    </CompassMenu>
</template>

<script>
import Feature from 'Services/Feature';
import { createAutomation } from 'api/automation/automationService';

import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

export default {
    data() {
        return {
            translations: {
                createAutomation: {
                    labelButton: this.$t.__('automation.AutomationLayout.create_automation'),
                    automation: this.$t.__('automation.AutomationLayout.create_actions_automation'),
                    automationCaption: this.$t.__(
                        'automation.AutomationLayout.create_actions_automation_caption',
                    ),
                    template: this.$t.__('automation.AutomationLayout.create_actions_template'),
                    templateCaption: this.$t.__(
                        'automation.AutomationLayout.create_actions_template_caption',
                    ),
                    services: this.$t.__('automation.AutomationLayout.create_actions_services'),
                    servicesCaption: this.$t.__(
                        'automation.AutomationLayout.create_actions_services_caption',
                    ),
                    flagLabel: this.$t.__('automation.AutomationLayout.create_actions_flag_label'),
                    tooltipContent: this.$t.__(
                        'automation.AutomationLayout.create_actions_tooltip_content',
                    ),
                },
            },
            isLoading: false,
        };
    },
    computed: {
        ...mapStateSystem(['errorsHandler']),
        getFlagPropsCreateAutomation() {
            return this.hasAutomationBuilderFeature
                ? {}
                : { label: this.translations.createAutomation.flagLabel };
        },
        getTooltipPropsCreateAutomation() {
            return this.hasAutomationBuilderFeature
                ? {}
                : { content: this.translations.createAutomation.tooltipContent, arrow: false };
        },
        hasAutomationBuilderFeature() {
            return Feature.isEnabled('automations-builder');
        },
    },
    methods: {
        handleCreateAutomation() {
            this.isLoading = true;
            createAutomation()
                .then((response) => {
                    if (response) {
                        this.$router.push({
                            name: 'automations.flow.builder',
                            params: { id: response.data.id },
                        });
                    }
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('automation.AutomationLayout.error.create_automation'),
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        handleGoToServices() {
            window.open('https://go.sellsy.com/demande-info-sellsy-services', '_blank');
        },
        handleGoToTemplates() {
            if (this.$route.name === 'automations.templates') {
                return;
            }
            this.$router.push({
                name: 'automations.templates',
            });
        },
    },
};
</script>

<style lang="scss">
.compass-menu__dropdown__container.automation-create-automation__menu {
    z-index: 3;
}
</style>
